module.exports = __webpack_public_path__ + "img/proj-help.27863ff3.svg";